import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import MembershipDemand from "../entities/membershipDemand";

interface MembershipDemandState extends ListState<MembershipDemand> {
  editMembershipDemand: MembershipDemand;
  permissions: Array<string>;
  treePermissions: Array<TreePermission>;
  recordList:Array<any>;
}

interface TreePermission {
  title: string;
  checked: boolean;
  expand: boolean;
  children: Array<TreePermission>;
}
class MembershipDemandModule extends ListModule<MembershipDemandState, any, MembershipDemand> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<MembershipDemand>(),
    loading: false,
    editMembershipDemand: new MembershipDemand(),
    permissions: new Array<string>(),
    treePermissions: new Array<TreePermission>(),
    recordList:new Array<any>()
  };
  actions = {
    async getAll(context: ActionContext<MembershipDemandState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/MembershipDemand/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<MembershipDemand>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<MembershipDemandState, any>, payload: any) {
      await Ajax.post(
        "/api/services/app/MembershipDemand/Create",
        payload.data
      );
    },
    async update(context: ActionContext<MembershipDemandState, any>, payload: any) {
      await Ajax.put(
        "/api/services/app/MembershipDemand/Update",
        payload.data
      );
    },
    async delete(context: ActionContext<MembershipDemandState, any>, payload: any) {
      await Ajax.delete(
        "/api/services/app/MembershipDemand/Delete?Id=" + payload.data.id
      );
    },
    async get(context: ActionContext<MembershipDemandState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/MembershipDemand/Get?Id=" + payload.id
      );
      return reponse.data.result as MembershipDemand;
    },
    async deleteImg(
      context: ActionContext<MembershipDemandState, any>,
      payload: any
    ) {
      return await Ajax.delete(
        "/api/services/app/MembershipDemandImage/Delete?Id=" + payload.data.id
      );
    },
    async getAllPermissions(context: ActionContext<MembershipDemandState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MembershipDemand/getAllPermissions"
      );
      context.state.permissions = reponse.data.result.items;
    },
    async getAllListByMembershipDemandId(context: ActionContext<MembershipDemandState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/MembershipDemandTrade/GetAllListByMembershipDemandId", {
        params: payload.data,
      });
      context.state.loading = false;
      context.state.totalCount = reponse.data.result.length;
      context.state.recordList =  reponse.data.result;
    },
  };
  mutations = {
    setCurrentPage(state: MembershipDemandState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: MembershipDemandState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: MembershipDemandState, membershipDemand: MembershipDemand) {
      state.editMembershipDemand = membershipDemand;
    },
  };
}
const membershipDemandModule = new MembershipDemandModule();
export default membershipDemandModule;
